import { render, staticRenderFns } from "./MaliangElementMenu.vue?vue&type=template&id=7890742c&scoped=true&"
import script from "./MaliangElementMenu.vue?vue&type=script&lang=js&"
export * from "./MaliangElementMenu.vue?vue&type=script&lang=js&"
import style0 from "./MaliangElementMenu.vue?vue&type=style&index=0&id=7890742c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7890742c",
  null
  
)

export default component.exports